import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { Input, FormFeedback, FormGroup, Label } from 'reactstrap';
import { firebase } from '../utils/firebase';
import Checkout from '../checkout';

class payment extends Component {
    constructor() {
        super()

        this.onHandleChange = this.onHandleChange.bind(this)
        this.submitProfile = this.submitProfile.bind(this)
        this.guid = this.guid.bind(this)

        this.state = {
            email: '',
            priceToPay: 31.95,
            comments: '',
            firstName: '',
            lastName:'',
            phoneNumberPrimary:'',
            userId: this.guid(),
            paid: false,
            paymentFrom: "AnimalOwner",
            businessName: "",
            agreeToPrivacy: false,
        }
    }
   
    
    render() {
        const user = this.state.currentUser;
        return (
            this.state.paid? 
            <h3>Thank you for your payment!</h3>:
           <div>              
            <h3>Direct Payment</h3>
            <br/>
            <h5>Payment Source</h5>
            <FormGroup style={{ display: 'flex', flexDirection: 'column', minWidth:'300px', margin: 'auto', marginBottom:'10px', width: '50%', justifyContent: 'center', alignSelf: 'center' }}>
              <Input type="select" name="paymentFrom" onChange={this.onHandleChange}>
                <option value='AnimalOwner'>Animal Owner</option>
                <option value='Business'>Business</option>
              </Input>
            </FormGroup>
            <br/>
            <h5>Contact Information</h5>
            {
              this.state.paymentFrom === "AnimalOwner" ? null :
            <FormGroup style={{ display: 'flex', flexDirection: 'column', minWidth:'300px', margin: 'auto', marginBottom:'10px', width: '50%', justifyContent: 'center', alignSelf: 'center' }}>
            <Input type="businessName" name="businessName" maxLength="50" id="businessName" placeholder="Business Name" onChange={this.onHandleChange} />
            </FormGroup>
              }
                <FormGroup style={{ display: 'flex', flexDirection: 'column', minWidth:'300px', margin: 'auto', marginBottom:'10px', width: '50%', justifyContent: 'center', alignSelf: 'center' }}> 
                        <Input type="email" name="email" maxLength="50" id="email" placeholder="Email" onChange={this.onHandleChange} />
                </FormGroup>
                <FormGroup style={{ display: 'flex', flexDirection: 'column', minWidth:'300px', margin: 'auto', marginBottom:'10px',  width: '50%', justifyContent: 'center', alignSelf: 'center' }}> 
                        <Input type="text" name="firstName" id="firstname" placeholder="First Name" onChange={this.onHandleChange} />
                </FormGroup>
                <FormGroup style={{ display: 'flex', flexDirection: 'column', minWidth:'300px', margin: 'auto', marginBottom:'10px',  width: '50%', justifyContent: 'center', alignSelf: 'center' }}> 
                        <Input type="text" name="lastName" id="lastName" placeholder="Last Name" onChange={this.onHandleChange} />
                </FormGroup>
                <FormGroup style={{ display: 'flex', flexDirection: 'column', minWidth:'300px', margin: 'auto', marginBottom:'10px',  width: '50%', justifyContent: 'center', alignSelf: 'center' }}> 
                        <Input type="text" maxLength="10" minLength="10" pattern="[0-9]*" placeholder="Phone Number" name="phoneNumberPrimary" id="phoneNumberPrimary" onChange={this.onHandleChange}/>
                </FormGroup>
                <FormGroup style={{ display: 'flex', flexDirection: 'column', minWidth:'300px', margin: 'auto', marginBottom:'10px', width: '50%', justifyContent: 'center', alignSelf: 'center' }}> 
                        <Input type="text" name="comments" id="comments" placeholder="Order Comments" onChange={this.onHandleChange} />
                       <br/>
                        <h5>Amount To Pay</h5>
                        <Input type="number" name="priceToPay" id="priceToPay" maxLength="8" min="0" placeholder="31.95" defaultValue={31.95} onChange={this.onHandleChange}/>
                    </FormGroup>   
                    <br/>

                    {
                    (this.state.paymentFrom==="AnimalOwner") ?  
                    null:
                    <FormGroup>
                      <input type="checkbox" name="agreeToPrivacy" id="agreeToPrivacy" defaultChecked={this.state.agreeToPrivacy} onChange={this.onHandleChange} zoom="2"></input>
                      By checking the box, you agree to the <a style={{color:"#37B349"}} href="https://verfidpet.com/terms-of-use" target="_blank">Terms</a> 
                      ,
                      <a style={{color:"#37B349"}} href="https://verfidpet.com/privacy-policy-1" target="_blank"> Privacy Policy</a>
                      , and
                      <a style={{color:"#37B349"}} href="https://verfidpet.com/npp" target="_blank"> Notice of Privacy Practices</a>
                    </FormGroup>
                    }
                     
                    {
                    (this.state.agreeToPrivacy || (this.state.paymentFrom==="AnimalOwner")) ? 
                        <Checkout
                        amount={parseInt(this.state.priceToPay*100,10)}
                        description={"VERFID Direct Payment"}
                        onSuccess={()=>this.submitProfile()}
                        userId={this.state.userId}
                        email={this.state.email}
                        />
                        :
                        null
                    }

            </div>
        
        )//return
    }

    onHandleChange(e) {
        var value = e.target.value;
        var name = e.target.name;
     

      if (name === 'agreeToPrivacy') {
        this.setState({
          agreeToPrivacy: !this.state.agreeToPrivacy,
        })
      }
      else{
        this.setState({
          [name]: value,
        })
      }
    }

    submitProfile(){
        
        var db = firebase.firestore();
        var location = db.collection('payments').doc(this.state.userId);
        //update firebase

        firebase.auth().signInAnonymously().catch(function(error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            // ...
          }).then(()=>{
          location.set(this.state) 
          }).then(()=>{
            this.setState({
                paid: true,
              })
            })    
      }

    
    
      guid() {
        return Date.now();;
      }

      loginAnom() {
        
       
      }


}

export default payment


// WEBPACK FOOTER //
// ./src/components/payment.js